export interface PurchaseDespatchProductReportInvoice {
  productKey: string;
  productDescription: string;
  supplierLineRef: string;
  grossQuantity: number;
  nettQuantity: number;
  price: number;
  value: number;
  unitOfMeasure: string;
  noOfItems: number;
  currencySymbol: string;
}
